import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgValidationX = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: "16px", height: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Assets", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { id: "assets", transform: "translate(-1087.000000, -2519.000000)" }, /* @__PURE__ */ React.createElement("g", { id: "icon/ValidationX", transform: "translate(1087.000000, 2519.000000)" }, /* @__PURE__ */ React.createElement("circle", { id: "Oval", fill: "#D0021B", cx: 8, cy: 8, r: 8 }), /* @__PURE__ */ React.createElement("path", { d: "M9.34616474,8 L11.5897726,10.2436079 C11.9615058,10.615341 11.9615058,11.2180395 11.5897726,11.5897726 C11.2180395,11.9615058 10.615341,11.9615058 10.2436079,11.5897726 L8,9.34616474 L5.7563921,11.5897726 C5.38465897,11.9615058 4.78196048,11.9615058 4.41022735,11.5897726 C4.03849423,11.2180395 4.03849423,10.615341 4.41022735,10.2436079 L6.65383526,8 L4.41022735,5.7563921 C4.03849423,5.38465897 4.03849423,4.78196048 4.41022735,4.41022735 C4.78196048,4.03849423 5.38465897,4.03849423 5.7563921,4.41022735 L8,6.65383526 L10.2436079,4.41022735 C10.615341,4.03849423 11.2180395,4.03849423 11.5897726,4.41022735 C11.9615058,4.78196048 11.9615058,5.38465897 11.5897726,5.7563921 L9.34616474,8 Z", id: "Combined-Shape", fill: "#FFFFFF" })))));
});
export default SvgValidationX;
